import React from 'react';
import {t} from "../../../components/Translate";
import Tooltip from "../../../components/Tooltip";
import AddIcon from "../../../assets/img/add.png";
import ExportIcon from "../../../assets/img/export.png";
import {toast} from "react-toastify";

const FileButtons = ({isFormVisible, toggleFormVisibility, user, config, API_URL, project, currentUser}) => {

    const {role} = user.data;
    const isManager = role === config.roles.manager;

    return (
        <div className="file-buttons">
            <div style={{
                height: '40px',
                alignItems: 'center',
                padding: '0 14px 0 14px',
                borderRadius: '15px',
                display: 'flex',
                gap: '35px',
                marginBottom: '20px',
                background: '#f1f3f5',
                width: 'fit-content',
                opacity: isManager ? 1 : 0.5,
                pointerEvents: isManager ? 'auto' : 'none'
            }}>
                <Tooltip text={t(currentUser.language, "add")}>
                    <img
                        style={{cursor: 'pointer'}}
                        onClick={isManager ? toggleFormVisibility : () => {
                            toast.error(t(currentUser.language, 'error'), {
                                position: "top-right",
                                theme: "light",
                                autoClose: 500,
                            })
                        }
                        }
                        width={25}
                        height={25}
                        src={AddIcon}
                    />
                </Tooltip>

                <Tooltip text={t(currentUser.language, "export")}>
                    <img
                        style={{cursor: 'pointer'}}
                        onClick={isManager ?
                            () => window.open(`${API_URL}/resource-provider/api/files/${project.name}`, '_blank')
                            : () => {
                                toast.error(t(currentUser.language, 'error'), {
                                    position: "top-right",
                                    theme: "light",
                                    autoClose: 500,
                                })
                            }
                        }
                        width={25}
                        height={25}
                        src={ExportIcon}
                    />
                </Tooltip>
            </div>

        </div>
    );
};

export default FileButtons;
